Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.ClipboardFormats = module.exports.default = {
	HTML_FORMAT: "air:html",
	RICH_TEXT_FORMAT: "air:rtf",
	TEXT_FORMAT: "air:text"
};